module.exports = __webpack_public_path__ + "static/img/profit.a4690559.png";